import { Breadcrumb } from "@refinedev/mui";
import { Box } from "@mui/material";
import PageHeading from "../../components/pageHeading";
export const StudentsTestedForAssessments = () => {
  return (
    <Box>
      <Breadcrumb />
      <PageHeading heading="Students tested for assessments (%)" />
    </Box>
  );
};
